<script>
export default {
    components: {
        VueEasyLightbox,
        ImgMedia,
    },
};
</script>
<script setup>
import { ref } from 'vue';
import VueEasyLightbox from 'vue-easy-lightbox';

// Components
import ImgMedia from '../Images/ImgMedia.vue';

const props = defineProps({
    gallery: Object,
});

const visibleRef = ref(false);
const indexRef = ref(0);
const showImg = (index) => {
    indexRef.value = index;
    visibleRef.value = true;
};
const onHide = () => (visibleRef.value = false);
</script>

<template>
    <div v-if="gallery" class="container my-8 md:my-16">
        <div class="grid gap-6 sm:grid-cols-2">
            <div
                v-for="(image, index) in gallery"
                :key="index"
                @click="() => showImg(index)"
                class="aspect-[500/420] relative pic"
            >
                <ImgMedia :media="image.image" alt="image" classes="object-cover w-full absolute inset-0 h-full" />
            </div>
        </div>

        <vue-easy-lightbox
            :visible="visibleRef"
            :moveDisabled="true"
            :imgs="gallery.map((item) => item.image.src)"
            :index="indexRef"
            @hide="onHide"
        ></vue-easy-lightbox>
    </div>
</template>
